import { effectiveSourceBpm, sessionBarsToNative, timelineBars } from '@/audio/clipTiming';

export function snapTrimEdge(rawBar, { fine, kiosk, pxPerBar }) {
  const whole = Math.round(rawBar);
  if (Math.abs(rawBar - whole) * pxPerBar <= 8) return whole;
  const step = fine && !kiosk ? 0.0625 : 0.25;
  return Math.round(rawBar / step) * step;
}

export function trimClip(clip, edge, targetBar, { bpm, availableNative, fine, kiosk, pxPerBar }) {
  const minSession = fine && !kiosk ? 0.0625 : 0.25;
  const minNative = sessionBarsToNative(minSession, clip, bpm);
  const start = Number(clip.start_bar || 0);
  const bars = Math.max(0, Number(clip.bars || 0));
  const offset = Math.max(0, Number(clip.offset || 0));
  const end = start + timelineBars(clip, bpm);
  const target = snapTrimEdge(targetBar, { fine, kiosk, pxPerBar });
  const available = Math.max(offset + bars, Number(availableNative ?? offset + bars));
  if (edge === 'left') {
    const low = Math.max(0, start - ((clip.reverse ? available-offset-bars : offset) * Number(bpm) / effectiveSourceBpm(clip, bpm)));
    const high = end - minSession;
    const nextStart = Math.min(high, Math.max(low, target));
    const delta = sessionBarsToNative(nextStart - start, clip, bpm);
    return { ...clip, start_bar: nextStart, offset: Math.max(0, offset + (clip.reverse ? 0 : delta)), bars: Math.max(minNative, bars - delta), isWholeLoop: false };
  }
  const low = start + minSession;
  const maxEnd = start + (clip.reverse ? offset+bars : available-offset) * Number(bpm) / effectiveSourceBpm(clip, bpm);
  const nextEnd = Math.min(maxEnd, Math.max(low, target));
  const nextBars=Math.max(minNative,sessionBarsToNative(nextEnd-start,clip,bpm));
  return { ...clip, bars: nextBars, offset: clip.reverse?Math.max(0,offset+bars-nextBars):offset, isWholeLoop:false };
}

export function resetClipLength(clip, availableNative) {
  return { ...clip, offset: 0, bars: Math.max(0, Number(availableNative)), isWholeLoop: true };
}

export function sliceRightOffset(clip, leftNativeBars) {
  return Math.max(0, Number(clip.offset || 0) + Number(leftNativeBars || 0));
}
